import gql from 'graphql-tag';
import { CommentsFragments } from '@getaccept/lib-shared/src/contextual-commenting/graphql/comments.fragments';

export class CommentsMutations {
  static create = gql`
    mutation CreateContextualComment($payload: CommentInput!) {
      createContextualComment(payload: $payload) {
        ...commentFragment
      }
    }
    ${CommentsFragments.comment}
  `;

  static update = gql`
    mutation UpdateContextualComment($payload: UpdateCommentInput!) {
      updateContextualComment(payload: $payload)
    }
  `;

  static createReply = gql`
    mutation CreateContextualCommentReply($payload: CommentReplyInput!) {
      createContextualCommentReply(payload: $payload) {
        ...replyFragment
      }
    }
    ${CommentsFragments.reply}
  `;

  static setReadBy = gql`
    mutation SetReadCommentsAndReplies($payload: SetContextualCommentAndRepliesReadbyInput!) {
      setContextualCommentsAndRepliesReadBy(payload: $payload)
    }
  `;

  static delete = gql`
    mutation DeleteContextualComment($commentId: String!) {
      deleteContextualComment(commentId: $commentId)
    }
  `;
}
